import { render, staticRenderFns } from "./HotStocks.vue?vue&type=template&id=9f0de7fe&scoped=true"
import script from "./HotStocks.vue?vue&type=script&lang=js"
export * from "./HotStocks.vue?vue&type=script&lang=js"
import style0 from "./HotStocks.vue?vue&type=style&index=0&id=9f0de7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0de7fe",
  null
  
)

export default component.exports